export const POLICY = { autoApprove: 5000, dailyBudget: 25000 };
export const COUNTERPARTIES = [
  { id: "vendor-7f3a", label: "vendor-7f3a · allowlisted", allow: true },
  { id: "api.openweather", label: "api.openweather · allowlisted", allow: true },
  { id: "custodian-ab12", label: "custodian-ab12 · allowlisted", allow: true },
  { id: "wallet-0x9e…c4", label: "wallet-0x9e…c4 · unknown", allow: false },
];
export const ACTIONS = [
  { id: "pay", label: "Pay API via x402", verb: "pay" },
  { id: "transfer", label: "Transfer funds", verb: "transfer" },
  { id: "sign", label: "Sign contract", verb: "sign" },
];
export const fmt = (n) => Number(n).toLocaleString("en-US");
export const evaluate = (p) => {
  const cp = COUNTERPARTIES.find((c) => c.id === p.counterparty);
  if (!cp?.allow) return { outcome: "deny", reason: "counterparty not allowlisted" };
  if (p.amount > POLICY.dailyBudget) return { outcome: "deny", reason: `exceeds $${fmt(POLICY.dailyBudget)}/day budget` };
  if (p.amount > POLICY.autoApprove) return { outcome: "escalate", reason: `above $${fmt(POLICY.autoApprove)} auto-approve limit` };
  return { outcome: "approved", reason: "within bound limits" };
};
